  document.addEventListener('DOMContentLoaded', function() {
    Navigation.init();
  });
  
  const Navigation = {
    selectors: {
        "header": { selector: ".header-nav", type: "single", scope: "document" },
        "mainLinks": { selector: ".main-nav .nav-links .toggle-link", type: "all", scope: "document" },
        "dropdownMainLinks": { selector: ".nav-dropdown .nav-links .toggle-link", type: "all", scope: "document" },
        "subLinks": { selector: ".link-group .sub-link", type: "all", scope: "document" },
        "mainNav": { selector: ".main-nav .nav-links", type: "single", scope: "document" },
        "navDropdown": { selector: ".nav-dropdown", type: "single", scope: "document" },
        "allDropdowns": { selector: ".dropdown-container", type: "all", scope: "document" },
        "modalBg": { selector: ".modal-background", type: "single", scope: "document" },
        "linkGroups": { selector: ".link-group", type: "all", scope: "document" },
        "closeBtns": { selector: ".nav-links .icon-close, .nav-dropdown .icon-close", type: "all", scope: "document" },
        "hamburger": { selector: ".mb-menu-open", type: "single", scope: "document" },
        "selectedCategories": { selector: ".selected-cat", type: "all", scope: "document" },
        "cartBtn": { selector: ".cart-link", type: "single", scope: "document" },
        "bonusBucksLearn": { selector: "a[href='/#bonus-bucks']", type: "all", scope: "document" },
        "bonusBucksModal": { selector: "#bonus-bucks-modal", type: "single", scope: "document" },
        "bonusBucksClose": { selector: ".bonus-bucks-close", type: "single", scope: "document" },
        "announcements": { selector: ".announcement-text div", type: "all", scope: "document" },
        "countdowns": { selector: ".countdown-date-nav", type: "all", scope: "document" },
        "miscLinks": { selector: ".link-group.misc-links", type: "all", scope: "document" }
    },
  
    fetchEls: function(selectors) {
        Object.entries(selectors).forEach(([key, {selector, type, scope}]) => {
            if (type === 'single') {
                if (scope === 'document') {
                    this[key] = document.querySelector(selector);
                } else {
                    this[key] = this.parent.querySelector(selector);
                }
            } else if (type === 'all') {
                if (scope === 'document') {
                    this[key] = document.querySelectorAll(selector);
                } else {
                    this[key] = this.parent.querySelectorAll(selector);
                }
            }
        });
    },     
  
    init: function() { 
        this.fetchEls(this.selectors);
        this.mobileCutoff = 1335;
        this.isMobile = window.innerWidth <= this.mobileCutoff;
        this.initEventListeners();
        this.initAnnouncementRotation();
        if (this.isMobile) {
          this.shiftLinkLayout();
        }
    },

    initEventListeners: function() {
      const {
        mainLinks,
        dropdownMainLinks,
        navDropdown,
        mainNav,
        modalBg,
        subLinks,
        linkGroups,
        closeBtns,
        hamburger,
        selectedCategories,
        cartBtn,
        bonusBucksLearn,
        bonusBucksModal,
        bonusBucksClose,
        countdowns
      } = this;

      this.calcTopPx();

      if (mainLinks.length > 0) {
        mainLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggleLinkCategory(link.dataset.linkCat);
          });
        });
      }

      if (dropdownMainLinks.length > 0) {
        dropdownMainLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.toggleLinkCategory(link.dataset.linkCat);
          });
        });
      }

      document.addEventListener('click', function(event) {
        let clickedInsideDropdownLinks = false;
    
        // Check if the click is inside the dropdown
        if (navDropdown && navDropdown.contains(event.target)) {
          // If it's inside the dropdown, don't close it
          clickedInsideDropdownLinks = true;
  
          // Also, if the close button is clicked, do not treat it as clicked inside dropdown links
          if (closeBtns && closeBtns.length > 0) {
            closeBtns.forEach((btn) => {
              if (btn.contains(event.target)) {
                clickedInsideDropdownLinks = false;
              }
            });
          }  
        } else {
          // If the click is outside the dropdown, check if it's on any of the main links
          if (mainLinks && mainLinks.length > 0) {
            mainLinks.forEach((link) => {
              if (link.contains(event.target)) {
                clickedInsideDropdownLinks = true;
              }
            });
          }
        }


        // If the click is not inside dropdown links, close the dropdown
        if (!clickedInsideDropdownLinks && navDropdown && navDropdown.classList.contains('active')) {
            navDropdown.classList.remove('active');
            if (window.innerWidth > 1200) {
                modalBg.style.display = 'none';
                mainNav.style.display = 'flex';
            }
        }
    });

      if (subLinks && subLinks.length > 0) {
        subLinks.forEach((link) => {
          link.addEventListener('click', function(event) {
            const curGroup = link.closest('.link-group');
            if (linkGroups && linkGroups.length > 0) {
              linkGroups.forEach((group) => {
                if (group === curGroup) {
                  curGroup.classList.toggle('active');
                } else {
                  group.classList.remove('active');
                }
              });
            }
          });
        });
      }

      if (closeBtns && closeBtns.length > 0) {
        closeBtns.forEach((btn) => {
          btn.addEventListener('click', function() {
            const parent = btn.closest('.parent-container');
            if (parent) {
              parent.classList.remove('active');
            }
          });
        });
      }

      if (hamburger) {
        hamburger.addEventListener('click', function() {
          if (mainNav) {
            mainNav.classList.add('active');
          }
        });
      }

      if (selectedCategories && selectedCategories.length > 0) {
        selectedCategories.forEach((category) => {
          category.addEventListener('click', () => {
            this.toggleLinkCategory(category.dataset.category);
          });
        });
      }  
       if (!window.location.href.includes('/cart') && cartBtn) {
          cartBtn.addEventListener('click', function(event) {
              event.preventDefault();
              Utility.hideProgressBarPopup();
              document.querySelector('html').classList.add('cart-show');
          });
        }

      if (bonusBucksLearn && bonusBucksLearn.length > 0 && bonusBucksModal && modalBg) {
        bonusBucksLearn.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            bonusBucksModal.style.display = 'block';
            modalBg.style.display = 'block';
          });
        });
      }

      if (bonusBucksClose && bonusBucksModal && modalBg) {
        bonusBucksClose.addEventListener('click', () => {
          bonusBucksModal.style.display = 'none';
          modalBg.style.display = 'none';
        });
      }

      if (countdowns && countdowns.length > 0) {
        countdowns.forEach((countdown) => {
          const dateString = countdown.dataset.countdown;
          const countdownText = countdown.dataset.countdownText;
          const targetDate = new Date(dateString);

          if (Number.isNaN(targetDate.valueOf())) {
            console.error("Invalid date:", dateString);

            return;
          }

          const updateCountdown = () => {
            const currentTime = new Date();
            const timeDifference = targetDate - currentTime;

            if (timeDifference <= 0) {
              countdown.textContent = "";
              clearInterval(intervalId);

              return;
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
            const seconds = Math.floor((timeDifference / 1000) % 60);

            countdown.textContent = "";

            const hyphen = document.createElement("span");
            hyphen.className = "countdown-hyphen";
            hyphen.textContent = "- ";

            countdown.appendChild(hyphen);
            countdown.appendChild(
              document.createTextNode(`${countdownText} ${days}d ${hours}h ${minutes}m ${seconds}s`)
            );
          };

          const intervalId = setInterval(updateCountdown, 1000);
          updateCountdown();
        });
      }

      window.addEventListener('resize', (event) => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const nowMobile = window.innerWidth <= this.mobileCutoff;
          console.log('resize detected, nowMobile:', nowMobile, 'wasMobile:', this.isMobile);
          if (nowMobile !== this.isMobile) {
            this.isMobile = nowMobile;
            this.calcTopPx();
            this.shiftLinkLayout();
          }
        }, 150);
      });
    },

    calcTopPx: function() {
      console.log('recalc top px');
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      console.log('header height:', headerHeight);
      if (this.navDropdown) {
        console.log('setting header offset');
          document.documentElement.style.setProperty('--header-offset', `${headerHeight - 1}px`);
      }
    },

    initAnnouncementRotation: function() {
      const {announcements} = this;
      // Nothing to rotate
      if (announcements.length === 1 || announcements.length === 0 ) {
        return;
      }
      let currentIndex = 0;

      function rotateBanners() {
        const currentBanner = announcements[currentIndex];
        const nextIndex = (currentIndex + 1) % announcements.length;
        const nextBanner = announcements[nextIndex];

        currentBanner.classList.remove("initial");

      
        // Add transition classes
        currentBanner.classList.remove("active");
        currentBanner.classList.add("prev");
    
        nextBanner.classList.add("active");
        nextBanner.classList.remove("prev");
    
        // Reset previous banner's state after animation
        setTimeout(() => {
          currentBanner.classList.remove("prev");
        }, 500);
    
        currentIndex = nextIndex;
      }
    
      // Initialize the first banner
      announcements[currentIndex].classList.add("active");
    
      // Rotate every 3 seconds
      setInterval(rotateBanners, 4000);
    },

    toggleLinkCategory: function(category) {
      const {allDropdowns, mainLinks, dropdownMainLinks, navDropdown, modalBg, isMobile} = this;

      if (isMobile) {
        navDropdown.classList.toggle('active');
      }
      mainLinks.forEach((mainLink) => {
        if (mainLink.dataset.linkCat === category) {
          mainLink.classList.add('active');
        } else {
          mainLink.classList.remove('active');
        }
      });
      allDropdowns.forEach((dropdown) => {
        if (dropdown.id === `dropdown-${category}`) {
          if (dropdown.style.display === 'block') {
            navDropdown.classList.remove('active');
            if (window.innerWidth > 1200) {
              modalBg.style.display = 'none';
            }
          } else {
            navDropdown.classList.add('active');
            if (window.innerWidth > 1200) {
              modalBg.style.display = 'block';
            }
          }
          // Toggle open/close for the clicked dropdown
          dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
        } else {
          // Always close all other dropdowns
          dropdown.style.display = 'none';
        }
      });

      dropdownMainLinks.forEach((link) => {
        if (link.dataset.linkCat === category) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    },

    shiftLinkLayout: function() {
      const { miscLinks, isMobile } = this;

      // Swap miscLinks and bottomLinks inside each dropdown
      miscLinks.forEach((link) => {
        const parent = link.closest('.dropdown-container');
        if (!parent) return;

        const bottomLinks = parent.querySelector('.bottom-links');
        if (!bottomLinks) return;

        // Create temporary placeholders
        const miscPlaceholder = document.createElement('div');
        const bottomPlaceholder = document.createElement('div');

        // Insert placeholders
        link.parentNode.insertBefore(miscPlaceholder, link);
        bottomLinks.parentNode.insertBefore(bottomPlaceholder, bottomLinks);

        // Swap elements
        miscPlaceholder.replaceWith(bottomLinks);
        bottomPlaceholder.replaceWith(link);
      });
    }
  };